<template>
  <v-list-item @click="toggleChatAgent" v-if="!isVectorRecruiting">
    <v-list-item-icon>
      <icon-base icon="custom/ai" />
    </v-list-item-icon>
    <v-list-item-title class="pr-2"> Ask CY </v-list-item-title>
  </v-list-item>
</template>

<script>
import EventBus from '@/factories/eventBus';

export default {
  name: 'ChatAgentLink',
  methods: {
    toggleChatAgent() {
      EventBus.$emit('openChatAgent');
    },
  },
};
</script>
